/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-16 18:19:40
 * @LastEditTime: 2025-04-10 15:15:10
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\information\details\index.tsx
 * @Description: 招生政策详情
 */
import FileDisplay from "@/components/file_display";
import ModuleCont from "@/components/moduleCont";
import { CommmonGet } from "@/util/network/api";
import { useTopHeight96 } from "@/util/public";
import { downloadFile, previewFile } from "@/util/util";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './index.scss';

function Information() {

  const service = {
    detail: '/informationManagement/preInformation',
    countViews: '/portal/homepage/countViews'
  }

  // 页面处理
  useTopHeight96()

  const location = useLocation();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('infoId')

  // 刷新
  const [isloading, setIsloading] = useState<boolean>(false);

  const [info, setInfo] = useState<any>({});

  useEffect(() => {
    const fromNavigate = sessionStorage.getItem('fromNavigate');
    if (fromNavigate) {
      // 跳转过来的
      sessionStorage.removeItem('fromNavigate'); // 清除标记
      CommmonGet(service.countViews + `/${id}`).then((res: any) => {
        console.log(res);
        setInfo(res?.data || {});
      });
    } else {
      // 页面刷新了
      init();
    }
  }, [id])

  const init = () => {
    setIsloading(true);
    CommmonGet(service.detail + `/${id}`).then((res: any) => {
      setInfo(res?.data || {});
    }).catch(error => {
      console.log(error);
    }).finally(() => { setIsloading(false); })
  }

  const newPage = (infoId) => {
    CommmonGet(service.countViews + `/${infoId}`).then((res: any) => {
      console.log(res);
    })
    window.scrollTo(0, 0);
    navigate(`/information/details?infoId=${infoId}`)
  }

  return (
    <div className="policyDetails">
      <Spin spinning={isloading}>
        <div className="plan_title">{info?.infoTitle}</div>
        <div className="plan_desc">
          <span style={{ marginRight: 30 }}>
            发布时间：{info?.releaseTime}
          </span>
          <span>浏览次数：{info?.times || '0'}次</span>
        </div>
        <div className="spit"></div>

        <div className="con_list">
          <div className="list">
            <div className="moremsg">
              <div style={{ marginBottom: 8 }}>
                <span className="content">
                  {/* {removeTags(info?.content || '')} */}
                  <div dangerouslySetInnerHTML={{ __html: info?.content || '' }}></div>
                </span>
              </div>
            </div>
          </div>
        </div>

        {info?.enclosure && info?.enclosure?.length > 0 &&
          <ModuleCont title='附件下载' section={2}>
            {info?.enclosure.map((ele: any) => {
              return <FileDisplay
                download={() => {
                  downloadFile(ele?.url || ele?.preUrl, ele?.originalName || ele?.name)
                }}
                show={() => { previewFile(ele) }}
                key={ele.md5Id || ele.resId}
                file={ele.originalName}
                panel
              />
            })}
          </ModuleCont>
        }
      </Spin>

      <div className="spit" style={{ marginBottom: 20 }}></div>
      <div className="pro_nex">
        <div>
          {info?.preInfo?.infoTitle && <div onClick={() => { newPage(info.preInfo.infoId) }} style={{ cursor: 'pointer' }}>
            上一篇：
            <span className="onclik_cls">
              {info?.preInfo?.infoTitle}
            </span>
          </div>}
        </div>
        {info?.nextInfo?.infoTitle &&
          <div onClick={() => { newPage(info.nextInfo.infoId) }} style={{ cursor: 'pointer' }}>
            下一篇：
            <span className="onclik_cls">
              {info?.nextInfo?.infoTitle}
            </span>
          </div>
        }
      </div>
    </div>
  )
}

export default Information
